import React from "react";

const ChatDev = () => {
  return (
    <div className="flex w-full justify-between items-center px-5 py-1 text-sm text-black">
      <a
        className="tracking-wider hover:no-underline hover:text-gray-600 hover:scale-105 transition-all duration-300"
        href="https://jaano.ai"
        target="_blank"
        rel="noopener noreferrer">
        © Powered by <strong>Jaano.ai</strong>
      </a>{" "}
      AI-generated content, please cross verify.
    </div>
  );
};

export default ChatDev;
